import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-policy',
  templateUrl: './data-policy.component.html',
  styleUrls: ['./data-policy.component.scss'],
})
export class DataPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
